import { useSpaceParameterControlledFilter } from '@src/components/AppLayout/SpaceParameters';
import { CUSTOMER_ASSET_TRANSACTIONS_COLUMNS } from '@src/containers/Blotters/CustomerAssetTransactions/useCustomerAssetTransactionsColumns';
import {
  CUSTOMER_ASSET_TRANSACTIONS_SPACE_PARAMETER_SUPPORT,
  isIncludedCustomerAssetTransaction,
  useCustomerAssetTransactionsFilterableProperties,
} from '@src/containers/Blotters/CustomerAssetTransactions/useCustomerAssetTransactionsFilter';
import { CUSTOMER_ASSET_TRANSACTION, EntityAdmin, type AssetTransaction } from '@talos/kyoko';

const WS_REQUEST = { name: CUSTOMER_ASSET_TRANSACTION, tag: 'CustomerAssetTransactions', sort_by: '-Timestamp' };

const PERSIST_KEY = 'dealer/customer-margin/asset-transactions';

export function CustomerAssetTransactions() {
  const availableFilterableProperties = useCustomerAssetTransactionsFilterableProperties();
  const { externallyControlledFilter, filterableProperties } = useSpaceParameterControlledFilter(
    CUSTOMER_ASSET_TRANSACTIONS_SPACE_PARAMETER_SUPPORT,
    availableFilterableProperties
  );

  return (
    <EntityAdmin<AssetTransaction>
      title="Customer Asset Transactions"
      subtitle="View customer asset transactions"
      entityName="Customer Asset Transaction"
      wsRequest={WS_REQUEST}
      entityIDField="TID"
      columns={CUSTOMER_ASSET_TRANSACTIONS_COLUMNS}
      allowAddEntity={false}
      allowEditEntity={false}
      allowDeleteEntity={false}
      persistKey={PERSIST_KEY}
      filterableProperties={filterableProperties}
      externallyControlledFilter={externallyControlledFilter}
      userFilterFunc={isIncludedCustomerAssetTransaction}
      useTabs={false}
    />
  );
}
